(function () {
  'use strict';

  console.log('[Decal Length Sync] Script loaded');

  const DECAL_LENGTH_SELECTOR =
    '#infiniteoptions-container select[name="properties[Decal length]"]';

  function normalizeLength(value) {
    if (!value) return '';

    return value
      .trim()
      .replace(/['’]/g, '')
      .replace(/\s*(ft|feet)\s*$/i, '')
      .trim();
  }

  function getDecalLengthField() {
    return document.querySelector(DECAL_LENGTH_SELECTOR);
  }

  function getSelectedShopifyLength() {
    /*
     * Look for the currently selected Shopify variant option.
     * We identify it by the fact that its label contains a
     * fence-length value such as 17', 18', 21.5', etc.
     */

    const checkedInputs = document.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (const input of checkedInputs) {
      const label = input.closest('label');

      if (!label) continue;

      const text = label.textContent.trim();

      /*
       * Fence lengths in this setup are numeric values,
       * optionally followed by an apostrophe.
       */
      if (/^\d+(?:\.\d+)?['’]?$/.test(text)) {
        return text;
      }
    }

    return '';
  }

  function syncDecalLength() {
    const decalLengthField = getDecalLengthField();

    /*
     * If this product doesn't have the Infinite Options
     * decal-length field, do nothing.
     */
    if (!decalLengthField) return;

    const shopifyLength = getSelectedShopifyLength();

    if (!shopifyLength) return;

    const normalizedShopifyLength =
      normalizeLength(shopifyLength);

    const matchingOption = Array.from(
      decalLengthField.options
    ).find(function (option) {
      return (
        normalizeLength(option.value) ===
        normalizedShopifyLength
      );
    });

    if (!matchingOption) {
      console.warn(
        '[Decal Length Sync] No matching decal length for:',
        shopifyLength
      );
      return;
    }

    /*
     * Already synchronized.
     */
    if (decalLengthField.value === matchingOption.value) {
      return;
    }

    console.log(
      '[Decal Length Sync]',
      shopifyLength,
      '→',
      matchingOption.value
    );

    /*
     * Set the Infinite Options field.
     */
    decalLengthField.value = matchingOption.value;

    /*
     * Tell Infinite Options that its field changed.
     */
    decalLengthField.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  /*
   * Listen at the document level so this continues working
   * even if Shopify replaces the variant picker markup.
   */
  document.addEventListener('change', function (event) {
    const target = event.target;

    if (
      target.matches(
        'input[type="radio"]'
      )
    ) {
      /*
       * Wait briefly for Shopify to finish its own
       * variant-selection work before synchronizing
       * Infinite Options.
       */
      setTimeout(syncDecalLength, 150);
    }
  });

  /*
   * Try the initial synchronization after page load.
   * Infinite Options may load slightly after the theme.
   */
  let attempts = 0;

  const initialSync = setInterval(function () {
    syncDecalLength();

    attempts++;

    if (getDecalLengthField() || attempts >= 40) {
      clearInterval(initialSync);
    }
  }, 250);

})();
